import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { BsModalService } from 'ngx-bootstrap/modal';
import { ToastrService } from 'ngx-toastr';
import { ConnectionService } from 'src/app/connection.service';

@Component({
  selector: 'app-freeze-history',
  templateUrl: './freeze-history.component.html',
  styleUrls: ['./freeze-history.component.css']
})
export class FreezeHistoryComponent implements OnInit {
  freezeList: any;

  constructor(private conn: ConnectionService, private alert: ToastrService, private route: Router, private actRoute: ActivatedRoute, private modalService: BsModalService) {}
  ngOnInit() {
    this.getFreezeUnfreeze()
  }

  getFreezeUnfreeze() {
		this.conn.postUrl('vote/freezeList', {}).subscribe((res: any) => {
			if (res.success == true) {
				this.freezeList = res.data
			}
		})
	}
  copyText(val: string) {
    let selBox = document.createElement('input');
    selBox.value = val;
    document.body.appendChild(selBox);
    selBox.focus();
    selBox.select();
    document.execCommand('copy');
    document.body.removeChild(selBox);
    this.alert.success('Copied to the clipboard');
  }

}
